export default function() {
    $(document).on('on:PageUpdate', function(event) {
        $('#event-test-jquery').prepend($(`<li>Native Done!</li>`));
    });
}
